// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.ProductRatingStars svg[data-v-4829746c]{\n    fill:currentColor;\n    --tw-text-opacity:1;\n    color:rgba(161, 190, 185, var(--tw-text-opacity));\n}\n.ProductRatingStars svg.is-active[data-v-4829746c]{\n      --tw-text-opacity:1;\n      color:rgba(0, 0, 0, var(--tw-text-opacity))\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
